<template>
  <div id="index">
    <div class="pc">
      <div class="logo">
        <img src="@/assets/logo-main.png" class="icon" alt="senkoo im logo" />
      </div>
      <div class="pancel">
        <div class="chat-list">
          <div class="box">
            <div class="group-title">
              <p class="group-title-text">
                <img class="icon-group" src="@/assets/icon-group.svg" />
                项目群 ({{groups.length}})
              </p>
              <i @click="groupHandle" class="el-icon-plus btn btn-plus" :class="{active:showGroup}"></i>
            </div>
            <div class="chat-box">
              <div
                class="chat"
                v-for="(item,idx) in groups"
                :key="idx"
                @click="showChat(item.ID)"
                :class="[item.ID == current_group ? 'active' : '']"
              >
                <div class="slide-msg text-ellipsis">
                  <span>{{item.title}}</span>
                </div>
                <div class="badge">
                  <div v-if="item.chats && item.chats.length > 0" class="msg text-ellipsis">
                    {{item.chats[0].name}}:
                    <template v-if="item.chats[0].data">文件</template>
                    <template v-else>{{item.chats[0].content}}</template>
                  </div>
                  <div :class="{notify:item.notify_count > 0}"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="center-pancel">
          <div class="nav">
            <span>{{chatMessage.title}}</span>
            <div class="btn-box">
              <el-tooltip :content="current_user.name" placement="bottom">
                <img class="head" src="@/assets/user.png" v-if="true" @click="toExit" />
              </el-tooltip>
              <div class="user" @click="toExit" v-if="false">{{current_user.name.slice(-2)}}</div>
              <i class="el-icon-more btn btn-more" @click="showSideMenu = !showSideMenu"></i>
            </div>
          </div>
          <div class="empty-logo text nogroup" v-if="groups.length == 0">
            <img class="arrow" src="@/assets/arrow-left.png" />
            <div class="empty">
              <img class="img" src="@/assets/empty.png" />
              <div class="text">请先点击 + 创建项目群</div>
            </div>
          </div>
          <div class="empty-logo text" v-else-if="noSelect">
            <img src="@/assets/nochat.png" class="senkoo" @scroll="topVisible" />
          </div>
          <div v-else class="text bg messge">
            <div class="content" id="text-list">
              <template v-for="(item, idx) in chatMessage.chats">
                <div
                  class="date-format"
                  v-if="showDate(item,idx,chatMessage.chats)"
                  :key="'date-'+idx"
                >{{item.date|chatTime}}</div>
                <div
                  class="msg-item"
                  :key="'content-'+idx"
                  :class="[item && item.user_id == current_user.ID ? 'right-msg' : 'content-msg']"
                  v-if="item"
                >
                  <span class="name">{{item.name}}</span>
                  <div class="msg-body">
                    <span
                      v-if="item.timeago < 3 && item.user_id == current_user.ID"
                      class="recall"
                      @click="recall(item)"
                    >
                      <span>撤回</span>
                      <img src="@/assets/icon-recall.svg" />
                    </span>
                    <template v-if="item.data">
                      <template v-if="item.type == 'image/jpeg' || item.type == 'image/png'">
                        <img :src="item.data" class="img" @click="showBig(item.data)" />
                      </template>
                      <template v-else-if="item.type == 'application/pdf'">
                        <div class="file-data" @click="download(item.data)">
                          <img src="../../public/pdf.png" />
                          <p>{{item.data.split("/")[item.data.split("/").length - 1]}}</p>
                          <div class="handle">
                            <el-button @click="download(item.data)">下载</el-button>
                          </div>
                        </div>
                      </template>
                      <template
                        v-else-if="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' == item.type"
                      >
                        <div class="file-data" @click="download(item.data)">
                          <img src="../../public/excel.png" />
                          <p>{{item.data.split("/")[item.data.split("/").length - 1]}}</p>
                          <div class="handle">
                            <el-button @click="download(item.data)">下载</el-button>
                          </div>
                        </div>
                      </template>
                      <template v-else-if="'application/msword' == item.type">
                        <div class="file-data">
                          <img src="../../public/word.png" />
                          <p>{{item.data.split("/")[item.data.split("/").length - 1]}}</p>
                          <div class="handle">
                            <el-button @click="download(item.data)">下载</el-button>
                          </div>
                        </div>
                      </template>
                      <template
                        v-else-if="['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'].includes(item.type)"
                      >
                        <div class="file-data" @click="download(item.data)">
                          <img src="../../public/ppt.png" />
                          <p>{{item.data.split("/")[item.data.split("/").length - 1]}}</p>
                          <div class="handle">
                            <el-button @click="download(item.data)" size="mini">下载</el-button>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        <div class="file-data">
                          <img src="../../public/zip.png" />
                          <p>{{item.data.split("/")[item.data.split("/").length - 1]}}</p>
                          <div class="handle">
                            <el-button @click="download(item.data)">下载</el-button>
                          </div>
                        </div>
                      </template>
                    </template>
                    <span v-else class="msg-style-body">{{item.content}}</span>
                  </div>
                </div>
              </template>
            </div>
            <div class="plugin" v-if="!noSelect">
              <div class="plugin-set">
                <el-upload
                  :action="actionUrl"
                  :show-file-list="false"
                  :on-success="sendUpload"
                  :before-upload="checkFile"
                  :on-progress="uploadProcess"
                  :on-error="uploadError"
                >
                  <i
                    slot="trigger"
                    class="el-icon-picture btn upload"
                    :class="{active:loading}"
                    size="small"
                  ></i>
                </el-upload>
              </div>
              <div
                class="input-text"
                v-if="!noSelect"
                v-loading="loading"
                :element-loading-text="'正在上传'+process+'%'"
              >
                <at :members="users.map(i => i.name)" style="width:99%;height:97%;">
                  <div
                    ref="paste"
                    type="text"
                    placeholder="输入内容"
                    class="input-text-form"
                    contenteditable
                    @paste.stop.prevent="pasteImage($event)"
                    @input="onInput"
                    @drop.prevent="addFile"
                    @dragover.prevent
                    @keydown.enter="send"
                  ></div>
                </at>
                <div class="btn-send">
                  <el-button @click="send" icon="el-icon-s-promotion">发送</el-button>
                </div>
              </div>
            </div>
            <div class="keys" v-if="showSideMenu">
              <el-tabs
                v-if="!noSelect"
                v-model="activeName"
                :stretch="true"
                @tab-click="handleClick"
              >
                <el-tab-pane
                  :label="'项目列表(' + keys.length + ')'"
                  class="tab-project"
                  name="project"
                >
                  <div class="user-list" v-if="false">
                    <div v-for="(item, idx) in keys" :key="idx" class="keyword">
                      <span class="href" @click="toMessage(item)">{{item.title}}</span>
                      <el-tag
                        :type="item.status === 1 ? 'success' : 'warning'"
                      >{{item.status === 1 ? "完成" : "讨论中"}}</el-tag>
                    </div>
                  </div>
                  <Topics :keys="keys" @toMessage="toMessage" />
                </el-tab-pane>
                <el-tab-pane :label="'群成员(' + users.length + ')' " name="user">
                  <UserList
                    :users="users"
                    :chatMessage="chatMessage"
                    :currentGroup="current_group"
                    @delUser="delUser"
                    @complete_event="addComplete"
                    @userHandle="userHandle"
                  />
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </div>
      </div>
      <GroupNew v-if="showGroup" :show.sync="showGroup" @created="groupCreated" />
      <el-dialog :visible.sync="show" width="80%" top="1%" :before-close="handleClose">
        <img :src="images" class="show-image" />
      </el-dialog>
      <el-dialog v-if="false" :visible.sync="showGroup" width="30%" top="1%" title="建群">
        <div class="group-form">
          <el-form ref="group_form" :model="group_form" label-width="80px">
            <el-form-item label="群名称">
              <el-input v-model="group_form.title"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="createGroup">立即创建</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="showUser" width="40" top="1%" title="这里找人">
        <user
          :show_user="showUser"
          :group_users="users"
          :room_id="current_group"
          v-on:complete_event="addComplete"
        />
      </el-dialog>
      <span class="copyright">版权所有 © SENKOO. All rights reserved. 沪ICP备18042729号-1</span>
    </div>
    <div class="mobile">
      <Nav>
        释空即时通讯
        <i slot="suffix" class="el-icon-plus btn" @click="$router.push({name:'groupNew'})"></i>
      </Nav>
      <div class="box" v-if="groups.length > 0">
        <div
          class="chat"
          v-for="(item,idx) in groups"
          :key="idx"
          @click="$router.push({name:'groupChat',params:{id:item.ID}})"
          :class="[item.ID == current_group ? 'active' : '']"
        >
          <div class="title text-ellipsis">
            <span>{{item.title}}</span>
            <span class="time">{{fmtTime2(item.UpdatedAt)}}</span>
          </div>
          <div class="badge">
            <div v-if="item.chats && item.chats.length > 0" class="msg text-ellipsis">
              {{item.chats[0].name}}:
              <template v-if="item.chats[0].data">文件</template>
              <template v-else>{{item.chats[0].content}}</template>
            </div>
            <div :class="{notify:item.notify_count > 0}"></div>
          </div>
        </div>
      </div>
      <div v-else class="box empty-box">
        <img class="arrow" src="@/assets/dash-arrow.png" />
        <div class="empty">
          <img class="img" src="@/assets/empty.png" />
          <div class="text">请先点击 + 创建项目群</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { formatDate, formatTime, timeSince, chatTime } from "../util";
import User from "../components/User.vue";
import { MessageBox } from "element-ui";
import axios from "axios";
import At from "vue-at";
import UserList from "@/components/UserList";
import Topics from "@/components/Topics";
import GroupNew from "@/components/GroupNew";
import Nav from "@/components/Nav";
export default {
  components: { User, At, UserList, Topics, GroupNew, Nav },
  filters: { chatTime },
  data() {
    return {
      msg: "",
      images: null,
      show: false,
      sock: null,
      current_user: JSON.parse(localStorage.getItem("user")),
      groups: [],
      chatMessage: { chats: [{ name: "", date: "" }] },
      keys: [],
      users: [],
      loadProcess: null,
      process: 0,
      noSelect: true,
      loading: false,
      activeName: "project",
      actionUrl: process.env.VUE_APP_BASE_URL + "/upload",
      current_group: localStorage.getItem("group"),
      showGroup: false,
      showUser: false,
      group_form: {},
      paste_value: "text",
      paste_file: null,
      at_users: [],
      top_load: false,
      page: 1,
      has_next: true,
      showSideMenu: true
    };
  },
  mounted() {
    this.getGroups();
    if (this.current_group) {
      this.showChat(this.current_group);
    }
    this.$notification.requestPermission().then(i => {
      if (i == "denied") {
        // MessageBox("通知未开启");
        this.$confirm("开启通知?", "通知未开启", {
          type: "warning",
          customClass: "permision-dialog"
        }).then(() => {});
      }
    });
    window.addEventListener("scroll", this.topVisible, true);
    // console.log("current user:", this.current_user);
  },
  computed: {
    fmtTime2() {
      return function(val) {
        // console.log("fmtTime2:", val);
        if (val) {
          return chatTime(val);
        }
        return "";
      };
    }
  },
  methods: {
    fmtTime(date) {
      return chatTime(date);
    },
    groupCreated(group) {
      this.groups = [group].concat(this.groups);
      this.current_group = group.ID;
      this.getGroupUser(this.current_group);
      this.showChat(this.current_group);
    },
    toExit() {
      this.$confirm("确认退出登录么？", { type: "warning" }).then(() => {
        // console.log("to exit user");
        localStorage.clear();
        this.$router.push({ name: "login" });
      });
    },
    showDate(item, idx, chats) {
      const last = chats[idx - 1];
      if (last && item) {
        const diff = Math.abs(last.date / 1000 - item.date / 1000);
        // console.log('if show date:',diff,item.date,last.date)
        return diff > 60;
      }
      return false;
    },
    topVisible() {
      const textlist = document.getElementById("text-list");
      if (!textlist) {
        return;
      }
      const pageHeight = textlist.scrollTop;
      if (pageHeight == 0) {
        // console.log("ss", this.has_next);
        this.top_load = true;
        if (!this.has_next) {
          return;
        }
        this.$api
          .getMessage({
            page: this.page + 1,
            room_id: this.chatMessage.ID,
            limit: 100
          })
          .then(res => {
            this.chatMessage.chats = res.result.messages
              .reverse()
              .concat(this.chatMessage.chats);
            this.page = this.page + 1;
            this.has_next = res.result.page.has_next;
          });
      }
    },
    toMessage(item) {
      // console.log('to message:',item)
      if (item.download == 1) {
        this.$router.push({ path: "/message", query: { mid: item.room_id } });
      }
    },
    onInput(e) {
      this.msg = e.target.innerText;
    },
    addFile(e) {
      let fs = e.dataTransfer.files;
      let f = fs[0];
      this.paste_file = f;
      this.sendPasteFile();
    },
    pasteImage(e) {
      const cbd = e.clipboardData;
      const ua = window.navigator.userAgent;
      if (!(e.clipboardData && e.clipboardData.items)) {
        return;
      }
      let value = cbd.getData("text/plain");
      if (value.length > 0) {
        this.msg = value;
        var node = document.createElement("span");
        node.innerHTML = value;
        this.$refs.paste.appendChild(node);
        return;
      }
      if (
        cbd.items &&
        cbd.items.length === 2 &&
        cbd.items[0].kind === "string" &&
        cbd.items[1].kind === "file" &&
        cbd.types &&
        cbd.types.length === 2 &&
        cbd.types[0] === "text/plain" &&
        cbd.types[1] === "Files" &&
        ua.match(/Macintosh/i) &&
        Number(ua.match(/Chrome\/(\d{2})/i)[1]) < 49
      ) {
        return;
      }
      for (let i = 0; i < cbd.items.length; i++) {
        let item = cbd.items[i];
        if (item.kind == "file") {
          const blob = item.getAsFile();
          if (blob.size === 0) {
            return;
          }
          const reader = new FileReader();
          const imgs = new Image();
          imgs.file = blob;
          this.paste_value = "file";
          reader.onload = (function(aImg) {
            return function(e) {
              aImg.src = e.target.result;
            };
          })(imgs);
          reader.readAsDataURL(blob);
          this.paste_file = blob;
          this.$refs.paste.appendChild(imgs);
        }
      }
    },
    deletUser(user, idx) {
      var that = this;
      MessageBox({
        title: "踢除成员",
        message: `确定将${user.name}移出群吗?`,
        type: "warning",
        callback: action => {
          if (action == "confirm") {
            that.removeUserFromRoom(user, idx);
          }
        }
      });
    },
    uploadError() {
      this.loading = false;
      MessageBox({
        title: "错误",
        message: "上传文件失败",
        type: "warning"
      });
    },
    delUser(idx) {
      this.users.splice(idx, 1);
    },
    removeUserFromRoom(user, idx) {
      this.$api
        .deleteUser({
          id: this.chatMessage.ID,
          user_id: user.ID,
          remove: user.ID
        })
        .then(res => {
          if (res.code == 200) {
            this.users.splice(idx, 1);
          }
        });
    },
    addComplete(isPass) {
      // this.showUser = false;
      // console.log("add complete:", this.current_group, isPass);
      if (isPass) {
        this.getGroupUser(this.current_group);
      } else {
        this.getGroups();
        if (this.current_group) {
          this.showChat(this.current_group);
        }
      }
    },
    download(e) {
      window.location.href = e;
    },
    groupHandle() {
      this.showGroup = true;
    },
    userHandle() {
      this.showUser = true;
    },
    handleClick(tab) {
      if (tab.name == "project") {
        this.getProject(this.current_group);
      } else if (tab.name == "user") {
        this.getGroupUser(this.current_group);
      }
    },

    getProject(id) {
      this.$api.getRoomInfo({ id: id, project: true }).then(res => {
        this.keys = res.result.projects;
      });
    },
    getGroupUser(id) {
      this.$api.getRoomInfo({ id: id, users: true }).then(res => {
        this.users = [...res.result.users];
      });
    },
    createGroup() {
      var groups = this.groups;
      this.$api.createGroup(this.group_form).then(res => {
        if (res.code == 200) {
          this.group_form = {};
          this.showGroup = false;
          this.groups = [res.result.room].concat(groups);
        }
      });
    },
    getGroups() {
      this.$api.groups().then(res => {
        this.groups = res.result.groups.map(i => {
          let cnt = localStorage.getItem(i.token);
          i.notify_count = cnt ? cnt : 0;
          return i;
        });
        this.connectService();
      });
    },
    converDate(date) {
      // console.log("date:", date);
      var t = formatDate(date);
      var ct = formatDate(new Date());
      if (ct == t) {
        return formatTime(date);
      }
      return t;
    },
    chatLog() {
      this.$nextTick(() => {
        var div = document.getElementById("text-list");
        if (div) {
          div.scrollTop = div.scrollHeight;
        }
      });
    },
    checkFile(file) {
      const limit = file.size / 1024 / 1024 < 3096;
      if (!limit) {
        alert("文件超过了 3G");
        return false;
      }
    },
    uploadProcess(event, file, filelist) {
      console.log("uploadProcess:", file, filelist);
      this.loading = true;
      this.process = Math.round((event.loaded * 100) / event.total);
    },
    connectService() {
      var uri = `${process.env.VUE_APP_SOCKET_URL}/ws?utoken=${this.current_user.token}&uid=${this.current_user.ID}`;
      this.sock = new WebSocket(uri);
      this.sock.onmessage = this.message_event;
      this.sock.onopen = this.open_event;
      this.sock.onerror = this.error_event;
      this.sock.onclose = this.close_event;
    },
    open_event() {
      console.log("连接成功");
    },
    error_event(e) {
      console.log("关闭连接", e);
      this.sock.close();
    },
    notify(title, content) {
      this.$notification.show(title, { body: content }, {});
    },
    message_event(e) {
      let data = JSON.parse(e.data);
      // console.log("sockts :", data);
      if (data.Sender == "") {
        return;
      }
      if (
        this.current_user.token != data.Sender &&
        data.Content.event != "recall"
      ) {
        var cnt = localStorage.getItem(data.Recipient);
        if (!cnt) {
          localStorage.setItem(data.Recipient, 1);
          this.handleNotifyCount(data.Recipient, 1);
        } else {
          localStorage.setItem(data.Recipient, parseInt(cnt) + 1);
          this.handleNotifyCount(data.Recipient, parseInt(cnt) + 1);
        }

        if (data.Content.content) {
          this.notify(
            data.Content.room_title,
            `${data.Content.name}: ${data.Content.content}`
          );
        } else if (data.Content.data && data.Content.data.length > 10) {
          this.notify(
            data.Content.room_title,
            `${data.Content.name}: 发了一个文件`
          );
        }
      }
      if (data.Sender == "system") {
        if (data.Content.event == "recall") {
          this.chatMessage.chats.splice(
            this.chatMessage.chats.findIndex(
              i => i.ID == parseInt(data.Content.mid)
            ),
            1
          );
          return;
        }
        if (data.Content.event == "new_group") {
          if (this.current_user.token == data.Recipient) {
            this.groups = [data.Content.room].concat(this.groups);
          }
        } else if (data.Content.event == "project") {
          if (this.chatMessage.token == data.Recipient) {
            if (data.Content.status == 1) {
              this.keys.map(i => {
                if (i.title == data.Content.filename) {
                  i.status = 1;
                }
                return i;
              });
            } else {
              let exists = this.keys.filter(
                i => i.title == data.Content.filename
              );
              if (exists.length > 0) {
                return;
              }
              this.keys.push({ title: data.Content.filename, status: 0 });
            }
          }
        } else if (data.Content.event == "delete") {
          let gidx = this.groups.findIndex(i => i.ID == data.Content.room_id);
          this.groups.splice(gidx, 1);
          if (data.Content.room_id == this.current_group) {
            this.chatMessage = {};
            this.noSelect = true;
            localStorage.removeItem("group");
          }
        }
        return;
      }
      // console.log("origin data:", data.Content);
      const update = data.Content.date;
      data.Content.date = parseInt(data.Content.date);
      if (this.chatMessage.token == data.Recipient) {
        data.Content.timeago = timeSince(data.Content.date);
        // console.log("timeago:", data.Content.timeago);
        if (this.chatMessage.chats) {
          this.chatMessage.chats.push(data.Content);
        } else {
          this.chatMessage.chats = [data.Content];
        }
      }
      let gps = this.groups.filter(i => i.token == data.Recipient)[0];
      gps.UpdatedAt = update;
      // console.log("date:", gps.UpdatedAt, update, data.Content.date);
      if (gps.chats == null) {
        gps.chats = [data.Content];
      } else {
        gps.chats.unshift(data.Content);
      }
      this.chatLog();
    },
    close_event(e) {
      console.log("连接关闭, 正在一秒后重新连接", e.reason);
      setTimeout(() => {
        this.connectService();
      }, 5000);
    },
    showBig(e) {
      this.images = e;
      this.show = true;
    },
    handleClose() {
      this.images = false;
      this.show = false;
    },
    uploadEvent(e) {
      let f = e.target.files[0];
      if (f.type == "image/jpeg" || f.type == "image/png") {
        this.toBase64(e.target.files[0]);
      } else {
        alert("不支持的格式");
        return;
      }
    },
    sendUpload(res, file, filelist) {
      console.log("sendUpload:", file, filelist);
      this.loading = false;
      if (res.code === 200) {
        let data = res.result.url;
        let size = res.result.size;
        let type = res.result.type["Content-Type"][0];
        let msg = {
          name: this.current_user.name,
          type: type,
          data: data,
          size: size.toString(),
          user_id: this.current_user.ID,
          room_id: this.chatMessage.ID,
          room_title: this.chatMessage.title,
          room_token: this.chatMessage.token,
          recipient: this.chatMessage.token,
          date: new Date().getTime().toString()
        };
        this.sock.send(JSON.stringify(msg));
        this.chatLog();
      }
    },
    toBase64(f) {
      var fr = new FileReader();
      var that = this;
      fr.readAsDataURL(f);
      fr.onload = e => {
        that.sendPasteFile(e.target.result);
        that.chatLog();
      };
    },
    handleNotifyCount(token, count) {
      this.groups.map(i => {
        if (i.token == token) {
          i.notify_count = count;
        } else {
          i.notify_count = 0;
        }
        return i;
      });
    },
    showChat(e) {
      this.showSideMenu = false;
      this.noSelect = false;
      localStorage.setItem("group", e);
      this.current_group = e;
      this.$api.getChat({ id: e }).then(res => {
        let tid = res.result.chat.token;
        this.chatMessage = res.result.chat;
        this.$api
          .getMessage({ room_id: e, page: 1, limit: 100 })
          .then(result => {
            this.chatMessage.chats = result.result.messages.reverse().map(i => {
              i.timeago = timeSince(i.date);
              return i;
            });
            this.page = 1;
            this.has_next = result.result.page.has_next;
            this.chatLog();
            localStorage.removeItem(tid);
            this.groups.map(i => {
              if (i.ID == e) {
                i.notify_count = 0;
              }
              return i;
            });
          });
      });
      this.getProject(e);
      this.getGroupUser(e);
    },
    sendPasteFile() {
      let formData = new FormData();
      formData.append("file", this.paste_file);
      axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
      axios({
        method: "post",
        url: this.actionUrl,
        data: formData
      })
        .then(result => {
          let res = result.data;
          if (res.code === 200) {
            let data = res.result.url;
            let size = res.result.size;
            let type = res.result.type["Content-Type"][0];
            let msg = {
              name: this.current_user.name,
              type: type,
              data: data,
              size: size.toString(),
              user_id: this.current_user.ID,
              room_id: this.chatMessage.ID,
              room_title: this.chatMessage.title,
              room_token: this.chatMessage.token,
              recipient: this.chatMessage.token,
              date: new Date().getTime().toString()
            };
            this.sock.send(JSON.stringify(msg));
            this.chatLog();
            this.paste_file = null;
            this.paste_value = "text";
            this.$refs.paste.innerHTML = "";
          }
        })
        .catch(err => {
          console.log("Err", err);
        });
    },
    recall(item) {
      // console.log("sd", item);
      this.$api
        .recallMessage({ id: item.room_id, recall: item.ID })
        .then(res => {
          if (res.code == 200) {
            this.chatMessage.chats.splice(
              this.chatMessage.chats.findIndex(i => i.ID == item.ID),
              1
            );
          }
        });
    },
    send() {
      if (this.paste_value == "file") {
        this.sendPasteFile();
        return;
      }
      let m = this.msg.trim();
      if (this.msg.length <= 0 || m.length <= 0) {
        return;
      }

      var msg = {
        name: this.current_user.name,
        ID: this.current_user.ID,
        content: this.msg,
        type: "text",
        user_id: this.current_user.ID,
        room_id: this.chatMessage.ID,
        room_title: this.chatMessage.title,
        room_token: this.chatMessage.token,
        recipient: this.chatMessage.token,
        date: new Date().getTime().toString()
      };
      this.msg = "";
      this.$refs.paste.innerHTML = "";
      this.sock.send(JSON.stringify(msg));
    }
  }
};
</script>
<style lang="scss" scoped>
#index {
  // border: 1px dashed red;
  min-height: 100vh;
  position: relative;
  background: url(../assets/back.png) no-repeat center center fixed;
  background-size: cover;
  height: 100%;
  overflow: hidden;
  .pc {
    display: block;
    .pancel {
      width: 1000px;
      height: 780px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 10;
      // border: 1px dashed black;
      border-radius: 5px;
      display: flex;
      justify-content: space-between;
      background: #fff;
      .chat-list {
        width: 200px;
        border-radius: 5px 0 0 5px;
        position: relative;
        .box {
          width: 200px;
          position: absolute;
          box-shadow: 2px 0px 4px 0px rgba(0, 0, 0, 0.07);
          z-index: 100;
          height: 100%;
          .group-title {
            padding: 0 30px;
            width: 100%;
            height: 70px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .btn-plus {
              font-weight: bold;
            }
            .group-title-text {
              vertical-align: middle;
              display: flex;
              align-items: center;
              .icon-group {
                width: 18px;
                height: 18px;
                margin-right: 8px;
              }
            }
          }
          .chat-box {
            height: calc(100% - 70px);
            overflow-y: auto;
            .chat {
              background: #fff;
              box-sizing: border-box;
              padding: 15px 30px;
              height: 70px;
              border-bottom: 1px solid #f2f2f2;
              display: flex;
              flex-direction: column;
              align-items: center;
              align-content: center;
              // border: 1px dashed red;
              cursor: pointer;
              .slide-msg {
                width: 100%;
                color: hsla(0, 0%, 20%, 1);
                font-size: 14px;
                line-height: 14px;
                height: 14px;
              }
              .text-ellipsis {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .badge {
                width: 100%;
                margin-top: 10px;
                height: 14px;
                font-size: 12px;
                line-height: 12px;
                color: hsla(0, 0%, 60%, 1);
                display: flex;
                justify-content: space-between;
                position: relative;
                .msg {
                }
                .notfiy {
                  width: 10px;
                  height: 14px;
                  margin-left: 10px;
                  position: relative;
                }
                .notify::after {
                  position: absolute;
                  content: "";
                  top: 50%;
                  right: 0;
                  transform: translateY(-50%);
                  display: block;
                  width: 8px;
                  height: 8px;
                  border-radius: 4px;
                  background: red;
                  z-index: 999;
                }
              }
            }
            .chat.active {
              background: #f0f0f0;
            }
          }
        }
      }
      .center-pancel {
        width: calc(100% - 200px);
        // border: 1px dashed orange;
        .nav {
          // width: 100%;
          height: 70px;
          display: flex;
          // border: 1px dashed red;
          justify-content: space-between;
          align-items: center;
          padding: 0 20px;
          border-bottom: 1px solid #e6e6e6;
          .btn-box {
            display: inline-flex;
            justify-content: flex-end;
            .head {
              width: 35px;
              height: 35px;
              border-radius: 50%;
              box-shadow: 0px 2px 4px 0 rgba(39, 176, 175, 0.4);
              cursor: pointer;
            }
            .user {
              width: 35px;
              height: 35px;
              border-radius: 50%;
              display: flex;
              justify-content: center;
              align-items: center;
              background: hsla(0, 0%, 84%, 1);
              cursor: pointer;
            }
            .btn-more {
              margin-left: 30px;
              // border: 1px dashed orange;
              align-self: center;
            }
          }
        }
        .empty-logo {
          height: calc(100% - 70px);
          // height: 97vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          background: hsla(0, 0%, 95%, 1);
          .senkoo {
            width: 262.5px;
            height: 102px;
          }
          .slogan {
            color: #909090;
          }
        }
        .text {
          background: hsla(0, 0%, 95%, 1);
        }
        .messge {
          height: calc(100% - 70px);
          position: relative;
          .content {
            height: calc(100% - 200px);
            overflow-y: auto;
            .date-format {
              text-align: center;
              font-size: 12px;
              color: hsla(0, 0%, 60%, 1);
            }
            .msg-item {
              margin: 15px 0;
              display: flex;
              flex-direction: row;
              .name {
                margin: 0 20px;
                min-width: 45px;
                font-size: 14px;
                color: hsla(0, 0%, 20%, 1);
              }
              .msg-body {
                max-width: 70%;
                border-radius: 3px 8px 8px 8px;
                background: hsla(0, 0%, 100%, 1);
                padding: 10px;
                .img {
                  max-width: 100%;
                }
                .msg-style-body {
                  color: hsla(0, 0%, 20%, 1);
                  font-size: 14px;
                  line-height: 24px;
                }
                .handle-event {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                }
              }
            }
            .right-msg {
              flex-direction: row-reverse;
              .msg-body {
                border-radius: 8px 3px 8px 8px;
                background: #d3f4f3;
                position: relative;
                display: inline-flex;
                justify-content: flex-start;
                .recall {
                  display: none;
                  justify-content: flex-end;
                  align-items: center;
                  position: absolute;
                  left: -26px;
                  bottom: 0;
                  // border: 1px dashed red;
                  z-index: 101;
                  width: 90px;
                  padding-right: 20px;
                  span {
                    margin-right: 10px;
                    color: #666;
                    font-size: 12px;
                  }
                  img {
                    width: 26px;
                    height: 26px;
                    // margin-left: 10px;
                  }
                }
                .recall:hover {
                  color: hsla(180, 64%, 42%, 1);
                  // background: hsla(180, 64%, 42%, 0.05);
                }
              }
              .msg-body:hover {
                .recall {
                  display: flex;
                  left: -90px;
                  color: hsla(180, 64%, 42%, 1);
                  cursor: pointer;
                }
              }
            }
          }
          .plugin {
            // border: 1px dashed red;
            border-top: 1px solid hsla(0, 0%, 86%, 1);
            height: 200px;
            .plugin-set {
              // border: 1px dashed deepskyblue;
              .upload {
                // border: 1px dashed red;
                font-size: 18px;
                margin: 10px 20px;
              }
            }
            .input-text {
              height: 164px;
              // border: 1px dashed deepskyblue;
              position: relative;
              .input-text-form {
                padding: 5px;
                height: 99%;
                outline: none;
                background: #f0f0f0;
                // border: 1px dashed skyblue;
              }
              .btn-send {
                display: none;
                position: absolute;
                right: 10px;
                top: 50%;
                transform: translateY(-50%);
                z-index: 102;
                // border: 1px dashed orangered;
              }
            }
          }
          .keys {
            position: absolute;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 103;
            width: 300px;
            height: 710px;
            background: hsla(0, 0%, 95%, 1);
            border-left: 1px solid hsla(0, 0%, 90%, 1);
            /deep/ .el-tabs__item {
              height: 60px;
              line-height: 60px;
            }
            /deep/ .el-tabs__item.is-active {
              color: hsla(180, 64%, 42%, 1);
            }
            /deep/ .el-tabs__active-bar {
              background-color: hsla(180, 64%, 42%, 1);
            }
          }
        }
        .nogroup {
          position: relative;
          .arrow {
            position: absolute;
            width: 75px;
            height: 72.5px;
            top: 15px;
            left: 15px;
          }
          .empty {
            // margin-top: 50px;
            text-align: center;
            color: hsla(0, 0%, 20%, 1);
            font-size: 14px;
            .img {
              width: 171px;
              height: 150px;
            }
          }
        }
      }
    }
    .logo {
      position: absolute;
      top: 22.5px;
      left: 25px;
      text-align: center;
      .icon {
        width: 109px;
        height: 44.5px;
      }
    }
    .copyright {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 14px;
      color: hsla(0, 0%, 20%, 1);
    }
    .show-image {
      width: 100%;
    }
    .file-data {
      border: 1px solid #f2f2f2;
      background: #fff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 5px;
      font-size: 12px;
      .handle {
        width: 100%;
        .el-button {
          width: 100%;
        }
      }
    }
  }
  .mobile {
    display: none;
  }
}
@media screen and (max-width: 750px) {
  .permision-dialog {
    max-width: 100%;
  }
  #index {
    .pc {
      display: none;
    }
    .mobile {
      display: block;
      height: 100vh;
      background: hsla(0, 0%, 95%, 1);
      .box {
        max-height: calc(100vh - 44px);
        overflow-y: auto;
        background: #fff;
        padding-left: 30px;
        // border: 1px dashed;
        .chat {
          background: #fff;
          padding: 12px 30px 8px 0;
          height: 70px;
          border-bottom: 1px solid #f2f2f2;
          display: flex;
          flex-direction: column;
          align-items: center;
          align-content: center;
          // border: 1px dashed red;
          cursor: pointer;
          .title {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: hsla(0, 0%, 0%, 1);
            font-size: 15px;
            line-height: 15px;
            .time {
              color: hsla(0, 0%, 60%, 1);
              font-size: 12px;
            }
          }
          .text-ellipsis {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .badge {
            width: 100%;
            margin-top: 10px;
            // height: 14px;
            font-size: 13px;
            line-height: 13px;
            color: hsla(0, 0%, 60%, 1);
            display: flex;
            justify-content: space-between;
            position: relative;
            // border: 1px dashed orange;
            .msg {
            }
            .notfiy {
              width: 10px;
              height: 14px;
              margin-left: 10px;
              position: relative;
            }
            .notify::after {
              position: absolute;
              content: "";
              top: 50%;
              right: 0;
              transform: translateY(-50%);
              display: block;
              width: 8px;
              height: 8px;
              border-radius: 4px;
              background: red;
              z-index: 999;
            }
          }
        }
      }
      .empty-box {
        position: relative;
        height: calc(100vh - 44px);
        padding-left: 0;
        .arrow {
          position: absolute;
          width: 75px;
          height: 72.5px;
          top: 15px;
          right: 25px;
        }
        .empty {
          margin-top: 215px;
          text-align: center;
          color: hsla(0, 0%, 20%, 1);
          font-size: 14px;
          .img {
            width: 171px;
            height: 150px;
          }
        }
      }
    }
  }
}
</style>
